export default __webpack_public_path__ + "static/media/Aura-Egg__21.4158f995.png";